import { generalEnv } from '@nx-frontend/shared/env';

/**
 * Replace Nimbus domains in the given URL
 * @param url
 * @returns
 */
export function replaceNimbusDomains(url: string, type: 'app' | 'base' | 'portal' = 'app'): string {
  const { nimbusDomain, appNimbusDomain } = generalEnv;

  let replaceTo = appNimbusDomain;
  if (type === 'app') {
    replaceTo = appNimbusDomain;
  }
  if (type === 'base') {
    replaceTo = nimbusDomain;
  }
  if (type === 'portal') {
    if (nimbusDomain === 'nimbusweb.me') {
      // in case if portal on domain without 'p.' prefix on nimbusweb.me instance, should do nothing
      return url;
    }
    replaceTo = nimbusDomain;
    if (!url.match(/\.p\.nimbusweb\.me/)) {
      replaceTo = `p.${nimbusDomain}`;
    }
  }
  return url.replace(/(dev-nimbustest\.com)|(nimbusweb\.me)/g, replaceTo);
}
